"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SidePanelToggleControl = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var video_context_1 = require("../../context/video-context");
var react_1 = require("@xstate/react");
var selectors_1 = require("../../selectors");
var use_player_prefs_1 = require("../../hooks/use-player-prefs");
var SidePanelToggleControl = function (_a) {
    var className = _a.className;
    var videoService = (0, video_context_1.useVideo)();
    var withSidePanel = (0, react_1.useSelector)(videoService, selectors_1.selectWithSidePanel);
    function handleClick() {
        videoService.send({ type: 'TOGGLE_SIDE_PANEL' });
        (0, use_player_prefs_1.savePlayerPrefs)({ theater: !withSidePanel });
    }
    return (React.createElement("button", { className: (0, classnames_1["default"])(className, {
            'cueplayer-react-icon-format-indent-decrease': !withSidePanel,
            'cueplayer-react-icon-format-indent-increase': withSidePanel
        }, 'cueplayer-react-side-panel-control cueplayer-react-control cueplayer-react-button cueplayer-react-icon'), type: "button", tabIndex: 0, onClick: handleClick },
        React.createElement("span", { className: "cueplayer-react-control-text" }, "Toggle side panel")));
};
exports.SidePanelToggleControl = SidePanelToggleControl;
